import React, { useEffect, useState } from "react";
import Sidebar from "../sidebar";
import Topnav from "../TopNav";
import { API_URL, token } from "../config";
import '../Courses/Courses.css';
import Swal from "sweetalert2";
import { getCurrentDate } from "../Components/DateFunction";
import { expDate } from "../Components/ExpDate";

const Modules = () => {
    const [dataSource, setDataSource] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [levelId] = useState(localStorage.getItem('levelId'));
    const [countLevel, setCountLevel] = useState(true);
    const [courseName, setCourseName] = useState('...Loading');
    const [collegeName, setCollegeName] = useState('...Loading');
    const [hide, setHide] = useState(false);
    const [userId] = useState(localStorage.getItem('userId'));
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [price] = useState(localStorage.getItem('price'));
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        // Check if user is admin on component mount
        const adminCheck = localStorage.getItem('userRole') === "Admin";
        setIsAdmin(adminCheck);
        if (adminCheck) {
            console.log("Admin Panel - Full Access Granted");
            setIsSubscribed(true); // Grant full access to admin
        }

        const handleResize = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth < 768) {
                setHide(true);
            }
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, []);

    useEffect(() => {
        // Filter topics based on search term
        const filtered = dataSource.filter(module =>
            module.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            module.description.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filtered);
    }, [searchTerm, dataSource]);

    const toggleSidebar = () => {
        setHide(prevHide => !prevHide);
    };

    // Standard Edition

    // const checkSubscription = async () => {
    //     // Skip subscription check for admin
    //     if (isAdmin) return;

    //     try {
    //         // Check if user has any active subscription for this course
    //         const response = await fetch(
    //             `${API_URL}/subscriptions/student/${userId}/${levelId}/${getCurrentDate()}`,
    //             {
    //                 method: 'GET',
    //                 headers: {
    //                     'Authorization': `Bearer ${token()}`
    //                 }
    //             }
    //         );
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }
    //         const data = await response.json();
    //         if (data.length >= 1) {
    //             setIsSubscribed(true);
    //         } else {
    //             setIsSubscribed(false);
    //         }
    //         console.log(data.length);
    //     } catch (error) {
    //         console.error("Error checking subscription:", error);
    //         return false;
    //     }
    // };

    // PROMO EDITION
    const checkSubscription = async () => {
        // Skip subscription check for admin
        localStorage.removeItem('PROMO');
        if (isAdmin) return;

        try {
            // Check if user has any active subscription for this course
            const response = await fetch(
                `${API_URL}/subscriptions/student/promo/${userId}/${levelId}/${getCurrentDate()}`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token()}`
                    }
                }
            );
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            let newCourseName = '';
            let newCollegeName = '';
            let newCourseLevel = '';
            let newCollegeLevel = '';

            // alert(data.course_name)
            console.log(data[0].course_name)
            console.log('This College: ', collegeName)

            newCourseName = data[0].course_name
            newCollegeName = collegeName

            if (newCourseName == 'Form 3' || newCourseName == 'Form 4' || newCourseName == 'O Level') {
                newCourseLevel = 'O-Level'
            }

            if (newCourseName == 'Lower Six' || newCourseName == 'Upper Six') {
                newCourseLevel = 'A-Level'
            }

            if (newCollegeName == 'Form 3' || newCollegeName == 'Form 4' || newCollegeName == 'O Level') {
                newCollegeLevel = 'O-Level'
            }

            if (newCollegeName == 'Lower Six' || newCollegeName == 'Upper Six') {
                newCollegeLevel = 'A-Level'
            }

            if (data.length >= 1) {
                if (data.length < 2) {
                    if (newCourseLevel == newCollegeLevel) {
                        setIsSubscribed(true);
                        localStorage.setItem('PROMO', true);
                    } else {
                        setIsSubscribed(false);
                        localStorage.setItem('PROMO', false);
                    }
                }else{
                    setIsSubscribed(true);
                    localStorage.setItem('PROMO', true);
                }
            } else {
                setIsSubscribed(false);
                localStorage.setItem('PROMO', false);
            }
            console.log(data.length);
        } catch (error) {
            console.error("Error checking subscription:", error);
            return false;
        }
    };

    const handleSubscribe = () => {
        Swal.fire({
            title: 'Subscribe to Full Access',
            html: `
                <p>Get unlimited access to all topics for just <strong>\$${price}/month</strong>.</p>
                <p>You'll be redirected to our secure payment processor.</p>
            `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Continue to Payment',
            cancelButtonText: 'Not Now'
        }).then((result) => {
            if (result.isConfirmed) {
                // Store course ID for payment processing
                localStorage.setItem('courseId', levelId);
                // Redirect to payment endpoint
                window.location.href = `${API_URL}/initiate-payment/${levelId}/0/${userId}/${price}/${expDate()}`;
            }
        });
    };

    const handleChannelClick = async (moduleId, isFirstTopic, e) => {
        e.preventDefault();

        // Allow full access for admin
        if (isAdmin) {
            localStorage.setItem('moduleId', moduleId);
            window.location.href = '/dashboard';
            return;
        }

        // Allow access if it's the first topic (trial) or user is subscribed
        if (isFirstTopic) {
            localStorage.setItem('freeTrial', true);
        } else {
            // Allow access to everyone
            localStorage.setItem('freeTrial', true);
            localStorage.setItem('moduleId', moduleId);
            window.location.href = '/dashboard';
            return;
            // localStorage.removeItem('freeTrial');
        }

        if (isFirstTopic || isSubscribed) {
            localStorage.setItem('moduleId', moduleId);
            window.location.href = '/dashboard';
            return;
        }

        // For non-subscribed users trying to access other topics
        Swal.fire({
            title: 'Subscription Required',
            html: `
                <p>You've accessed the free trial topic.</p>
                <p>Subscribe for <strong>\$${price}/month</strong> to unlock all topics.</p>
            `,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: `Subscribe Now`,
            cancelButtonText: 'Maybe Later'
        }).then((result) => {
            if (result.isConfirmed) {
                handleSubscribe();
            }
        });
    };

    const checkCourseName = async () => {
        try {
            const response = await fetch(`${API_URL}/courses/${levelId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setCourseName(data[0].name);
            setIsLoading(false);

            //Promo editions
            checkCollegeName(data[0].college_id)


        } catch (error) {
            console.error("Error fetching course name:", error);
        }
    };

    const checkCollegeName = async (id) => {
        try {
            const response = await fetch(`${API_URL}/colleges/${id}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });
            if (!response.ok) throw new Error('Network response was not ok');
            const data = await response.json();
            setCollegeName(data[0].name);
            // console.log('Coolege Name',data[0].name);
        } catch (error) {
            console.error("Error fetching course name:", error);
        }
    };

    const fetchModules = async () => {
        try {
            const response = await fetch(`${API_URL}/modules/course/${levelId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token()}`
                }
            });

            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();
            setDataSource(data);
            setFilteredData(data); // Initialize filtered data with all modules
            setCountLevel(data.length > 0);

            // Check subscription status (skipped for admin)
            if (data.length > 0 && !isAdmin) {
                await checkSubscription();
            }
        } catch (error) {
            console.error("Error fetching modules:", error);
        }
    };

    useEffect(() => {
        checkCourseName();
        // fetchModules();
    }, []);

    useEffect(() => {
        if (collegeName !== '...Loading') { // Ensure it's not the initial state
            fetchModules();
        }
    }, [collegeName]);

    return (
        <html lang="en">
            <body id="page-top">
                <div id="wrapper">
                    <Sidebar hide={hide}></Sidebar>
                    <div id="content-wrapper" className="d-flex flex-column">
                        <div id="content">
                            <Topnav title={courseName} toggleSidebar={toggleSidebar}></Topnav>
                            <div className="container-fluid" style={{ textAlign: 'left', overflow: 'auto', maxHeight: '85vh' }}>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h1 className="h3 mb-0 text-gray-800">Select Module</h1>
                                    {/* Search Box */}
                                    <div className="search-container" style={{ width: '300px' }}>
                                        <div className="input-group">
                                            <input
                                                type="text"
                                                className="form-control bg-light border-0 small"
                                                placeholder="Search topics..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                                style={{
                                                    borderRadius: '20px',
                                                    backgroundColor: '#a2c1f5',
                                                    padding: '10px 15px',
                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Subscription Info Banner */}
                                {/* {countLevel && (
                                    <div className={`alert ${isAdmin ? 'alert-success' : isSubscribed ? 'alert-success' : 'alert-info'} mb-3 d-flex justify-content-between align-items-center`}>
                                        {isAdmin ? (
                                            <span>✓ Admin: Full access granted</span>
                                        ) : isSubscribed ? (
                                            <span>✓ You have full access to all topics</span>
                                        ) : (
                                            <>
                                                <div>
                                                    <strong>Free Trial:</strong> First topic is free. Subscribe for <strong>${price}/month</strong> to access all topics.
                                                </div>
                                                <button className="d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                                    onClick={handleSubscribe}
                                                >
                                                    Subscribe
                                                </button>
                                            </>
                                        )}
                                    </div>
                                )} */}

                                {!countLevel && (
                                    <p style={{ fontSize: '18px', textAlign: 'center' }}><b>No Modules Available!</b></p>
                                )}

                                {countLevel && filteredData.length === 0 && !isLoading &&(
                                    <p style={{ fontSize: '18px', textAlign: 'center' }}><b>No modules match your search.</b></p>
                                )}

                                <div style={{ backgroundColor: 'white' }}>
                                    <div className="courses-table">
                                        {filteredData.map((module, index) => (
                                            <div className="course-item" key={module.module_id}>
                                                <img src="../img/class2.PNG" alt="" className="course-img" />
                                                <div className="course-info">
                                                    <a
                                                        href="/dashboard"
                                                        style={{color: '#27ad54'}}
                                                        className={`module-link ${!isAdmin && !isSubscribed && index > 1000 ? 'text-muted' : ''}`}
                                                        onClick={(e) => handleChannelClick(
                                                            module.module_id,
                                                            index === 0, // isFirstTopic
                                                            e
                                                        )}
                                                    >
                                                        {module.name}
                                                    </a>
                                                    <br />
                                                    <span>{module.description}</span>
                                                    {/* {isAdmin && (
                                                        <span className="badge bg-primary ms-2">Admin Access</span>
                                                    )}
                                                    {index === 0 && !isAdmin && !isSubscribed && (
                                                        <span className="badge bg-success ms-2">Free Trial</span>
                                                    )}
                                                    {index > 0 && !isAdmin && !isSubscribed && (
                                                        <span className="badge bg-warning ms-2">Subscribe to Access</span>
                                                    )} */}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </body>
        </html>
    );
};

export default Modules;